export enum ProductRecurringInterval {
    None,
    Monthly,
    Yearly,
}